import { Divider, Typography } from "antd";
import { useState } from "react";
import GraphView from "../../../components/EOL/EOL-dashboard/GraphView";
import CardView from "../../../components/EOL/EOL-dashboard/CardView";

const EOLdashboardPage = ({ userData }) => {

    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [graphData, setGraphData] = useState(null);

    const handleDataAvailability = (available) => {
        setIsDataAvailable(available);
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    EOL Dashboard
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <CardView userData={userData}
                onDataAvailable={handleDataAvailability}
                setGraphData={setGraphData} />

            {isDataAvailable && <GraphView graphData={graphData} />}
        </>
    )
};
export default EOLdashboardPage;